import { Controller } from "@hotwired/stimulus"
import { copyToClipboard } from "../utils/copy_to_clipboard"

export default class extends Controller {
  static values = {
    content: String,
    feedbackDuration: { type: Number, default: 1500 },
    successText: { type: String, default: "Copied!" },
    // "text" swaps the trigger's own label; "icon" leaves the markup alone and
    // only flips the copied class, so an icon-only trigger keeps its <img>.
    feedback: { type: String, default: "text" }
  }

  static targets = ["source", "trigger", "status"]

  copy(event) {
    event.preventDefault()

    const text = this.hasContentValue
      ? this.contentValue
      : this.hasSourceTarget
        ? this.sourceTarget.textContent.trim()
        : ""

    if (!text) return

    copyToClipboard(text).then((copied) => {
      if (copied) this.showFeedback()
      else console.error("Clipboard: copy failed")
    })
  }

  showFeedback() {
    const trigger = this.hasTriggerTarget ? this.triggerTarget : this.element
    trigger.classList.add("copied")
    this.announce(this.successTextValue)

    if (this.feedbackValue === "icon") {
      this.resetAfterFeedback(() => trigger.classList.remove("copied"))
      return
    }

    const originalText = trigger.textContent
    trigger.textContent = this.successTextValue

    this.resetAfterFeedback(() => {
      trigger.textContent = originalText
      trigger.classList.remove("copied")
    })
  }

  resetAfterFeedback(reset) {
    clearTimeout(this.feedbackTimeout)
    this.feedbackTimeout = setTimeout(() => {
      reset()
      this.announce("")
    }, this.feedbackDurationValue)
  }

  announce(message) {
    if (this.hasStatusTarget) this.statusTarget.textContent = message
  }
}
